var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1092_31231)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1092_31231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1365 11.9784L18.4105 11.1994C17.1829 10.8533 16.0647 10.198 15.1628 9.29611C14.2609 8.39424 13.6056 7.27601 13.2595 6.04842L12.4805 3.32242C12.4413 3.22704 12.3747 3.14547 12.289 3.08806C12.2034 3.03065 12.1026 3 11.9995 3C11.8964 3 11.7956 3.03065 11.71 3.08806C11.6243 3.14547 11.5577 3.22704 11.5185 3.32242L10.7395 6.04842C10.3934 7.27601 9.73807 8.39424 8.8362 9.29611C7.93432 10.198 6.81609 10.8533 5.5885 11.1994L2.8625 11.9784C2.75783 12.0081 2.66571 12.0712 2.60011 12.158C2.53451 12.2448 2.49902 12.3506 2.49902 12.4594C2.49902 12.5682 2.53451 12.6741 2.60011 12.7609C2.66571 12.8477 2.75783 12.9107 2.8625 12.9404L5.5885 13.7194C6.81609 14.0655 7.93432 14.7208 8.8362 15.6227C9.73807 16.5246 10.3934 17.6428 10.7395 18.8704L11.5185 21.5964C11.5482 21.7011 11.6112 21.7932 11.6981 21.8588C11.7849 21.9244 11.8907 21.9599 11.9995 21.9599C12.1083 21.9599 12.2141 21.9244 12.3009 21.8588C12.3877 21.7932 12.4508 21.7011 12.4805 21.5964L13.2595 18.8704C13.6056 17.6428 14.2609 16.5246 15.1628 15.6227C16.0647 14.7208 17.1829 14.0655 18.4105 13.7194L21.1365 12.9404C21.2412 12.9107 21.3333 12.8477 21.3989 12.7609C21.4645 12.6741 21.5 12.5682 21.5 12.4594C21.5 12.3506 21.4645 12.2448 21.3989 12.158C21.3333 12.0712 21.2412 12.0081 21.1365 11.9784Z",
    fill: "url(#paint0_linear_1092_31231)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1092_31231",
    x: 0.499023,
    y: 2,
    width: 23.001,
    height: 22.96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.392157 0 0 0 0 0.219608 0 0 0 0 0.960784 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1092_31231"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1092_31231",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1092_31231",
    x1: 3.5,
    y1: -6,
    x2: 17.6705,
    y2: -10.6926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A36BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1092_31231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProStar);
export default __webpack_public_path__ + "static/media/proStar.1172922a8f01638275a7e77688dd8800.svg";
export { ForwardRef as ReactComponent };